// extracted by mini-css-extract-plugin
export default {"holderCompany":"Company_holderCompany__qAhd2","information":"Company_information__oHTJ9","address":"Company_address__i2i2J","btnModify":"Company_btnModify__QZ73q"};